import { FC, useState } from "react";
import ButtonUI from "../../../../components/button/buttons";
import { Container, Stack, Typography } from "@mui/material";
import usePostDeleteAccountBank from "../../../../service/userBankAccount/deleteUserAccountBank";

interface DeleteAccountBankModal {
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  authToken?: string | null;
  data?: any;
  setModalNotification?: any;
  refresh?: any;
}

export const DeleteAccountBankModal: FC<DeleteAccountBankModal> = (props) => {
  const { loading, deleteAccountBank } = usePostDeleteAccountBank();

  const onClickRemove = async () => {
    try {
      const result = await deleteAccountBank(props.authToken || "", {
        account_number: props.data,
      });

      if (result.success === true) {
        props.setModalNotification({
          open: true,
          message: "Se ha eliminado la cuenta",
          severity: "success",
        });
        props.setOpenModal(false);
        props.refresh();
      } else {
        props.setModalNotification({
          open: true,
          message: "Ocurrio un error",
          severity: "error",
        });
      }

      // Asegúrate de que devuelva una promesa
    } catch (err: any) {
      props.setModalNotification({
        open: true,
        message: (err as Error).message || "Ocurrió un error",
        severity: "error",
      });
    }
  };

  return (
    <Container maxWidth="xs">
      <Stack direction="column" justifyContent="center" margin="5px">
        <Typography
          fontSize="26px"
          color="#1A455F"
          fontWeight="bold"
          align="center"
        >
          ¿Esta seguro de remover la cuenta bancaria?
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="center" margin="5px">
        <Typography fontSize="22px" fontWeight="bold" color="#00350392">
          Numero de cuenta
        </Typography>
        <Typography fontSize="22px">{": " + props?.data}</Typography>
      </Stack>

      <Stack
        direction="row"
        justifyContent="space-evenly"
        alignItems="center"
        padding="5px"
      >
        <ButtonUI
          id="button-back"
          title="Regresar"
          onClick={() => props.setOpenModal(false)}
        />
        <ButtonUI
          loading={loading}
          id="button-create-withdrawl"
          title="Remover cuenta"
          color="primary"
          onClick={() => onClickRemove()}
        />
      </Stack>
    </Container>
  );
};
